export default __webpack_public_path__ + "static/media/01-cloud.51c6bff0.png";